export const columnsDataFirmwareHistoryOverview = [
/*    {
        Header: 'SR',
        accessor: 'sr'
    },*/
/*    {
        Header: 'NAME',
        accessor: 'filename',
    },*/
    {
        Header: 'VERSION',
        accessor: 'version',
    },
    {
        Header: 'ACTIVE',
        accessor: 'active',
    },
    {
        Header: 'SIZE',
        accessor: 'fileSize',
    },
    {
        Header: 'CRC',
        accessor: 'crc',
    },
    {
        Header: 'UPLOAD TIME',
        accessor: 'createdTime',
    }
/*    {
        Header: 'RELEASE NOTES',
        accessor: 'releaseNotes',
    }*/
];
